// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-custom .web {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.navbar-custom .mobile {
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: space-between;
}
.navbar-custom .menu-item {
  display: flex;
  flex-direction: column;
  align-items: start;
  cursor: pointer;
  margin-bottom: 15px;
}
.navbar-custom h5 {
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  color: #ffffff;
}
.navbar-custom span {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #ffffff;
}
.navbar-custom a {
  text-decoration: none;
}
@media (min-width: 992px) {
  .navbar-custom .menu-item {
    margin-bottom: 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Navigation/navigation.scss","webpack://./src/components/Navigation/navigation.css"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;ACAJ;ADGE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,8BAAA;ACDJ;ADIE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;ACFJ;ADKE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACHJ;ADME;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACJJ;ADOE;EACE,qBAAA;ACLJ;ADQE;EACE;IACE,gBAAA;ECNJ;AACF","sourcesContent":[".navbar-custom {\n  .web {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .mobile {\n    display: flex;\n    align-items: start;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .menu-item {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    cursor: pointer;\n    margin-bottom: 15px;\n  }\n\n  h5 {\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 400;\n    color: #ffffff;\n  }\n\n  span {\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    color: #ffffff;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  @media (min-width: 992px) {\n    .menu-item {\n      margin-bottom: 0;\n    }\n  }\n}\n",".navbar-custom .web {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.navbar-custom .mobile {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.navbar-custom .menu-item {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  cursor: pointer;\n  margin-bottom: 15px;\n}\n.navbar-custom h5 {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #ffffff;\n}\n.navbar-custom span {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  color: #ffffff;\n}\n.navbar-custom a {\n  text-decoration: none;\n}\n@media (min-width: 992px) {\n  .navbar-custom .menu-item {\n    margin-bottom: 0;\n  }\n} /*# sourceMappingURL=navigation.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
